import Input from './Input'
import { parseText } from './components'

import './style.scss'

export { Input, parseText }
export default Input
